import React from "react";
import PropTypes from "prop-types";
import {eachDayOfInterval, lightFormat} from "date-fns";
import {DAY_STATUS} from "../shared/constants";
import {isoFmt} from "../shared/utils";


class StatusLegend extends React.PureComponent {
    static propTypes = {
        timeline: PropTypes.object,
        timelineRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
        selectRange: PropTypes.bool.isRequired,
        selectedRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired
    }

    calculateStatusCounts() {
        if (!this.props.selectRange)
            return {};

        const statusCount = Object.fromEntries(Object.keys(DAY_STATUS).map(key => [key, 0]));
        statusCount['OVERRIDE'] = 0;

        const [start, end] = this.props.selectedRange;
        for (const date of eachDayOfInterval({start, end})) {
            const dateStr = isoFmt(date);
            const dayProps = this.props.timeline[dateStr];
            const status = dayProps.statusOverride ?? dayProps.defaultStatus;
            statusCount[status] += 1;

            if (dayProps.statusOverride)
                statusCount.OVERRIDE += 1;
        }
        return statusCount
    }

    render() {
        const showCounts = this.props.selectRange;
        const statusCount = this.calculateStatusCounts();

        return (
            <ul id="legend" className='color-legend'>
                <li><span className="status-box workFromHome"/><span>Работа из дома в рабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.WORK_FROM_HOME]}`}</li>
                <li><span className="status-box workFromHomeNWD"/><span>Работа из дома в нерабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.WORK_FROM_HOME_NWD]}`}</li>
                <li><span className="status-box workFromOffice"/><span>Работа из офиса в рабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.WORK_FROM_OFFICE]}`}</li>
                <li><span className="status-box workFromOfficeNWD"/><span>Работа из офиса в нерабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.WORK_FROM_OFFICE_NWD]}`}</li>
                <li><span className="status-box fieldWorkInHomeCity"/><span>Работа на выезде в СПб в рабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.FIELD_WORK_HOME_CITY]}`}</li>
                <li><span className="status-box fieldWorkInHomeCityNWD"/><span>Работа на выезде в СПб в нерабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.FIELD_WORK_HOME_CITY_NWD]}`}</li>
                <li><span className="status-box fieldWorkInOtherCity"/><span>Работа на выезде в командировке в рабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.FIELD_WORK_OTHER_CITY]}`}</li>
                <li><span className="status-box fieldWorkInOtherCityNWD"/><span>Работа на выезде в командировке в нерабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.FIELD_WORK_OTHER_CITY_NWD]}`}</li>
                <li><span className="status-box onTheRoad"/><span>День в дороге</span>{showCounts && ` — ${statusCount[DAY_STATUS.FIELD_WORK_OTHER_CITY]}`}</li>
                <li><span className="status-box onTheRoadNWD"/><span>День в дороге в нерабочий день</span>{showCounts && ` — ${statusCount[DAY_STATUS.FIELD_WORK_OTHER_CITY_NWD]}`}</li>
                <li><span className="status-box timeOffPaid"/><span>Оплачиваемый отгул</span>{showCounts && ` — ${statusCount[DAY_STATUS.TIME_OFF_PAID]}`}, <span className="status-box timeOffPaidPending"/>- заявка</li>
                <li><span className="status-box timeOffUnpaid"/><span>Неоплачиваемый отгул</span>{showCounts && ` — ${statusCount[DAY_STATUS.TIME_OFF_UNPAID]}`}, <span className="status-box timeOffUnpaidPending"/>- заявка</li>
                <li><span className="status-box vacationPaid"/><span>Оплачиваемый отпуск</span>{showCounts && ` — ${statusCount[DAY_STATUS.VACATION_PAID]}`}, <span className="status-box vacationPaidPending"/>- заявка</li>
                <li><span className="status-box vacationUnpaid"/><span>Неоплачиваемый отпуск</span>{showCounts && ` — ${statusCount[DAY_STATUS.VACATION_UNPAID]}`}, <span className="status-box vacationUnpaidPending"/>- заявка</li>
                <li><span className="status-box illness"/><span>Больничный</span>{showCounts && ` — ${statusCount[DAY_STATUS.ILLNESS]}`}, <span className="status-box illnessPending"/>- заявка</li>
                <li><span className="status-box badge"/><span>Статус дня был изменен</span>{showCounts && ` — ${statusCount.OVERRIDE}`}</li>
                <li><span className="status-box"/><span>Нерабочий день + не было работ (но могла быть дорога)</span>{showCounts && ` — ${statusCount.EMPTY}`}</li>
            </ul>
        )
    }
}

export default StatusLegend;